import { Routes } from '@angular/router';
import { policyDetailsGuard } from './core/guards/policy-details.guard';
import { MsalGuard } from '@azure/msal-angular';
import { reportsGuard } from '@core/guards/reports.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/home/home.component').then(m => m.HomeComponent),
  },
  {
    path: 'reports',
    loadComponent: () =>
      import('./pages/report/report.component').then(m => m.ReportComponent),
    canActivate: [MsalGuard, reportsGuard]
  },
  {
    path: 'policy-details',
    loadComponent: () =>
      import('./pages/policy-detail/policy-detail.component').then(m => m.PolicyDetailComponent),
    canActivate: [MsalGuard, policyDetailsGuard]
  }

];
